//libs
import { useEffect, useMemo, useState } from 'react';

//helpers
import { ListItemProps } from './types';

export default function useSort<T extends ListItemProps>(actions: T[], defaultSortBy: string = '') {
  const [sortBy, setSortBy] = useState<string>(defaultSortBy);
  useEffect(() => {
    if (defaultSortBy !== sortBy) {
      setSortBy(defaultSortBy);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSortBy]);

  const sortActions = useMemo(
    () =>
      actions.map((action) => ({
        ...action,
        isSelected: action.id === sortBy,
      })),
    [actions, sortBy],
  );
  return {
    sortActions,
    sortBy,
    setSortBy,
  };
}
